export const ConstCss = {
    boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
    flexCenter: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex'
    },
    textNormal: {
        fontSize: 14,
        color: '#212121'
    }
};

export const Color = {
    white: '#ffffff',
    black: '#000000',
    primary: '#0358A7',
    grayBackground: '#F7F7F7',
    grayHeaderBack: '#F2F2F2',
    backText: '#212121',
    blue: '#0358A7',
    blueBackground: '#0358A7',
    yellow: '#FFC700',
    gray: '#828282',
    graySecond: '#6A6D70',
    grayText: '#605E5C',
    blackSecond: '#32363A',
    red: '#ff0000',
    grayNoData: '#BABABA',
    greyTableText: '#201F1E',
    warn: '#E9730C',
    tagPrimary: '#CAE4F3',
    tagSecondary: '#E9E9E9',
    grayButton: '#CCCCCC',
    blueLink: '#0854A0'
};

export const uploadFileFormat = [
    {
        filetype: ".txt",
        name: "text/plain"
    }, {
        filetype: ".pdf",
        name: "application/pdf"
    },
    {
        filetype: ".docx",
        name: "application/vnd.ms-word"
    }, {
        filetype: ".xls",
        name: "application/vnd.ms-excel"
    }, {
        filetype: ".xlsx",
        name: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    {
        filetype: ".png",
        name: "image/png"
    }, {
        filetype: ".jpg",
        name: "image/jpeg"
    }, {
        filetype: ".jpeg",
        name: "image/jpeg"
    }, {
        filetype: ".gif",
        name: "image/gif"
    }, {
        filetype: ".csv",
        name: "text/csv"
    }
];

export const constData = {
    year: [
        {
            "key": "2021",
            "text": "2021"
        },
        {
            "key": "2020",
            "text": "2020"
        },
        {
            "key": "2019",
            "text": "2019"
        },
        {
            "key": "2018",
            "text": "2018"
        }
    ]
}

export const specialCharacters = [8, 9, 18, 20, 91, 32, 16, 17, 27, 13];

export const ctrlCommandKeys = [65, 67, 88, 86];